import { Component, Inject, Input, OnInit } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from '@angular/material/dialog';
import { BuiltUpAreaLandDetailsComponent } from './details/builtup-area-land-details.component';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { ReportsService } from 'app/modules/admin/transactions/inwards/reports.service';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { BaseRespone } from 'app/core/models/common.response';
import { Observable, Subject } from 'rxjs';
import { BuiltUpAreaLandService } from './builtup-area-land.service';
import { BuiltUpAreaLand } from './builtUpAreaLand.types';
import { map, take, takeUntil } from 'rxjs/operators';
import { InwardReport } from 'app/modules/admin/transactions/inwards/reports.types';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
    selector: 'app-builtup-area-land',
    templateUrl: './builtup-area-land.component.html',
    styleUrls: ['./builtup-area-land.component.scss'],
})
export class BuiltUpAreaLandComponent implements OnInit {
    @Input() report: InwardReport;
    @Input() reportId: number;
    @Input() reportType: string;
    selection = new SelectionModel<BuiltUpAreaLand>(true, []);
    total: number = 0.0;
    totalSuperBuiltUp: number = 0.0;

    selectedBuiltUpAreaLand: BuiltUpAreaLand;
    selectedIds: number[] = [];
    isAllSelectedCheckBox: boolean = false;

    builtUpAreaLands$: Observable<BuiltUpAreaLand[]>;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    constructor(
        private _matDialog: MatDialog,
        private _matDialogRef: MatDialogRef<BuiltUpAreaLandComponent>,
        private _fuseConfirmationService: FuseConfirmationService,
        private _builtUpAreaLandService: BuiltUpAreaLandService,
        private _alertMessageService: AlertMessageService,
        @Inject(MAT_DIALOG_DATA)
        private _data: {
            report: InwardReport;
            reportId: number;
            reportType: string;
        }
    ) {
        this.report = _data.report;
        this.reportType = _data.reportType;
        this.reportId = _data.reportId;
    }

    ngOnInit(): void {
        this._builtUpAreaLandService
            .getBuiltUpAreaLands(this.reportId)
            .subscribe((res) => {
                this.calculateBuiltUpAreaLandsTotal();
            });

        this.builtUpAreaLands$ =
            this._builtUpAreaLandService.builtUpAreaLands$.pipe(
                map((data) => {
                    data?.sort((a, b) => {
                        return a.id < b.id ? -1 : 1;
                    });
                    return data;
                })
            );

        // Get the contact
        this._builtUpAreaLandService.builtUpAreaLand$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((contact: BuiltUpAreaLand) => {
                // Update the selected contact
                this.selectedBuiltUpAreaLand = contact;

                // Mark for check
                //this._changeDetectorRef.markForCheck();
            });

        // if (this.builtUpAreaLands.subscribe(re).length > 0) {
        //     this.calculateSiteMeasurementsTotal();
        // }
    }

    new(): void {
        let orderIndex = 0;
        this.builtUpAreaLands$.subscribe((result) => {
            orderIndex = result.length + 1;
        });

        this._matDialog
            .open(BuiltUpAreaLandDetailsComponent, {
                autoFocus: false,
                data: {
                    builtUpAreaLand: {
                        orderIndex: orderIndex,
                        areaAsPer: '',
                        area: '',
                        reportId: this.reportId,
                    },
                    reportType: this.reportType,
                },
            })
            .afterClosed()
            .subscribe(() => {});
    }

    edit(builtUpAreaLand: BuiltUpAreaLand): void {
        this._matDialog
            .open(BuiltUpAreaLandDetailsComponent, {
                autoFocus: false,
                data: {
                    builtUpAreaLand: builtUpAreaLand,
                    reportType: this.reportType,
                },
            })
            .afterClosed()
            .subscribe((response: BaseRespone<BuiltUpAreaLand>) => {});
    }

    /**
     * Delete the selected product using the form data
     */
    delete(id: number): void {
        // Open the confirmation dialog
        const confirmation = this._fuseConfirmationService.open({
            title: 'Delete BuiltUpAreaLand',
            message:
                'Are you sure you want to remove? This action cannot be undone!',
            actions: {
                confirm: {
                    label: 'Delete',
                },
            },
        });

        // Subscribe to the confirmation dialog closed action
        confirmation.afterClosed().subscribe((result) => {
            // If the confirm button pressed...
            if (result === 'confirmed') {
                //Delete the product on the server
                this._builtUpAreaLandService
                    .deleteBuiltUpAreaLand(id)
                    .subscribe((res) => {
                        if (res.isSuccess) {
                            this._alertMessageService.success(
                                'BuiltUpAreaLand deleted successfully'
                            );
                        } else {
                            this._alertMessageService.error(
                                res.errors.join('\n')
                            );
                        }
                    });
            }
        });
    }

    async deleteSelectedRows() {
        const confirmation = this._fuseConfirmationService.open({
            title: 'Delete All BuiltUpAreaLand',
            message:
                'Are you sure you want to remove? This action cannot be undone!',
            actions: {
                confirm: {
                    label: 'Delete',
                },
            },
        });

        const result = await confirmation.afterClosed().toPromise();

        if (result === 'confirmed') {
            const ids = this.selection.selected.map((item) => item.id);
            const res = await this._builtUpAreaLandService
                .deleteAllBuiltUpAreaLand(ids)
                .toPromise();

            if (res.isSuccess) {
                this._alertMessageService.success(
                    'BuiltUpAreaLand all deleted successfully'
                );
                this.selection.clear();
                this.builtUpAreaLands$.subscribe();
            } else {
                this._alertMessageService.error(res.errors.join('\n'));
            }
        }
    }
    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    calculateBuiltUpAreaLandsTotal(): void {
        this._builtUpAreaLandService.builtUpAreaLands$.subscribe((res) => {
            this.total = res.reduce((sum, current) => sum + current.area, 0);
           
            //     this.report.siteBuiltUp = res.reduce((sum, current) => sum + current.total, 0);
            //    // this.totalSuperBuiltUp = res.reduce((sum, current) => sum + current.siteSuperBuiltUp, 0);
        });
    }

    updateCheckedList(event, row) {
        this.builtUpAreaLands$.pipe(take(1)).subscribe((measurements) => {
            measurements.forEach((item) => {
                if (item.id == row.id) {
                    item.selected = event.checked;
                    if (item.selected) {
                        this.selection.select(item); // Select item in selection model
                    } else {
                        this.selection.deselect(item);
                    }
                }
            });

            this.isAllSelectedCheckBox = !measurements.some((a) => !a.selected);
        });
    }

    selectAll(event: any) {
        const checked = event.checked;
        this.builtUpAreaLands$
            .pipe(take(1))
            .subscribe((measurements: any[]) => {
                measurements.forEach((measurement) => {
                    measurement.selected = checked;
                });
            });
    }
    checkboxLabel() {
        if (this.isAllSelected()) {
            return 'Deselect all';
        }
        if (this.selection.isEmpty()) {
            return 'Select all';
        }
        return `${this.selection.selected.length} selected`;
    }

    isAllSelected() {
        // Check if all measurements are selected
        return this.builtUpAreaLands$.pipe(
            take(1),
            map((measurements) =>
                measurements.every((measurement) => measurement.selected)
            )
        );
    }

    toggleAllRows() {
        this.isAllSelected().subscribe((allSelected) => {
            if (!allSelected) {
                // Select all items
                this.builtUpAreaLands$
                    .pipe(take(1))
                    .subscribe((measurements) => {
                        measurements.forEach((item) => {
                            item.selected = true;
                            this.selection.select(item); // Select item in selection model
                        });
                    });
                this.isAllSelectedCheckBox = true;
            } else {
                // Deselect all items
                this.builtUpAreaLands$
                    .pipe(take(1))
                    .subscribe((measurements) => {
                        measurements.forEach((item) => {
                            item.selected = false;
                            this.selection.deselect(item); // Deselect item in selection model
                        });
                    });
                this.isAllSelectedCheckBox = false;
            }
        });
    }

    onClose(): void {
        const returnValue = {
            // populate with your form data or any other data
            total : this.total,
        }
        this._matDialogRef.close(returnValue);
    }
}
